import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/logs`;

class LogService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }

    public getProjectLogsList(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.create(body, { name: "projects/search" });
        } catch (e) {
            throw e;
        }
    }
    public getPlanLogsList(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}`;
            return super.create(body, { name: "plans/search" });
        } catch (e) {
            throw e;
        }
    }
    public getFiveYearLogPlanBody(id: number): Promise<IApiResponse | void> {
        try {
        return super.getById(id, { name: "5Yplandetail" });
        } catch (e) {
        throw e;
        }
    }
    
    public getNewDebtPlanLogDetail(id: number): Promise<IApiResponse | void> {
        try {
        return super.getById(id, { name: "newdebtplandetail" });
        } catch (e) {
        throw e;
        }
    }
}
const LogsAPI = new LogService(url);
export default LogsAPI;